
export default[
    {
        show(row,extra){
            var iswjbzbm=''
            for(var i=0;i<row.t_servicescorecommonpfs.length;i++) {
                if(row.t_servicescorecommonpfs[i].type==='1') {
                    iswjbzbm='1'
                }
            }
            return iswjbzbm===''&&row.tagkey!==null
        },
        tag:'my-btn',
        type:'edit',
        text:'文件编制部门评价',
        click(row,extra){
            row.type='1'
            this.$emit('getTk',row)
            
        }
    },{
        show(row,extra){
            var isend=''
            for(var i=0;i<row.t_servicescorecommonpfs.length;i++) {
                if(row.t_servicescorecommonpfs[i].type==='1') {
                    isend=row.t_servicescorecommonpfs[i].isend
                }
               
            }
            return row.t_servicescorecommonpfs.length>0&&isend==='0'
        },
        tag:'my-btn',
        type:'edit',
        text:'修改文件编制部门评价',
        click(row,extra){
            row.type='1'
            this.$emit('getEdit',row)
        }
    },{
        show(row,extra){
            var isend=''
            for(var i=0;i<row.t_servicescorecommonpfs.length;i++) {
                if(row.t_servicescorecommonpfs[i].type==='1') {
                    isend=row.t_servicescorecommonpfs[i].isend
                }
               
            }
            return row.t_servicescorecommonpfs.length>0&&isend==='1'
        },
        tag:'my-btn',
        type:'detail',
        text:'查看文件编制部门评价',
        click(row,extra){
            row.type='1'
            this.$emit('getDetail',row)
        }
    },
    ,{
        show(row,extra){
            var iszbdwpj=''
            for(var i=0;i<row.t_servicescorecommonpfs.length;i++) {
                if(row.t_servicescorecommonpfs[i].type==='2') {
                    iszbdwpj='1'
                }
            }
            return iszbdwpj===''
        },
        tag:'my-btn',
        type:'edit',
        text:'中标单位评价',
        click(row,extra){
            if(row.ggcode==null) {
                ShowMsg('中标单位尚未确定，请发布中标公告后再进行评价')
                return
            }
            row.type='2'
            this.$emit('getTk',row)
        }
    },
    ,{
        show(row,extra){
            var iszbdwpj=''
            for(var i=0;i<row.t_servicescorecommonpfs.length;i++) {
                if(row.t_servicescorecommonpfs[i].type==='2') {
                    iszbdwpj='1'
                }
            }
            return row.t_servicescorecommonpfs.length>0&&iszbdwpj==='1'
        },
        tag:'my-btn',
        type:'edit',
        text:'修改中标单位评价',
        click(row,extra){
            row.type='2'
            this.$emit('getEdit',row)
        }
    },
]